import React, { Fragment } from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const PoleDefault = (props: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox={props.viewBox ? props.viewBox : "0 0 50 50"}
    >
      <rect x="10" y="10" rx="3" ry="3" width="30" height="30" />
      {props.children}
    </SvgIcon>
  );
};

export const LabelPole = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox={props.viewBox ? props.viewBox : "0 0 50 50"}>
      <text x="25" y="30" textAnchor="middle">
        {props.children}
      </text>
    </SvgIcon>
  );
};

export const LampPole = (props: SvgIconProps) => {
  return (
    <Fragment>
      <line x1="5" y1="5" x2="11" y2="11" />
      <line x1="45" y1="5" x2="39" y2="11" />
      <line x1="45" y1="45" x2="39" y2="39" />
      <line x1="5" y1="45" x2="11" y2="39" />
    </Fragment>
  );
};

export const GroundPole = (props: SvgIconProps) => {
  return (
    <Fragment>
      <line x1="25" y1="40" x2="25" y2="44" />
      <line x1="20" y1="44" x2="30" y2="44" />
      <line x1="22" y1="46" x2="28" y2="46" />
      <line x1="24" y1="48" x2="26" y2="48" />
    </Fragment>
  );
};

export const CableDefault = (props: SvgIconProps) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 100 20">
      <line x1="0" y1="10" x2="100" y2="10" />
    </SvgIcon>
  );
};

export const CablePublic = (props: SvgIconProps) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 100 20">
      <line
        x1="10"
        y1="10"
        x2="90"
        y2="10"
        style={{ strokeWidth: props.style?.strokeWidth }}
      />
      <circle
        cx="50"
        cy="10"
        r="10"
        style={{ fillOpacity: 1, strokeWidth: 0 }}
      />
    </SvgIcon>
  );
};

export const CableLowAwBottom = (props: SvgIconProps) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 100 20">
      <line
        x1="0"
        y1="10"
        x2="30"
        y2="10"
        style={{ strokeWidth: props.style?.strokeWidth }}
      />
      <circle cx="50" cy="10" r="10" style={{ strokeWidth: 0 }} />
      <line
        x1="70"
        y1="10"
        x2="100"
        y2="10"
        style={{ strokeWidth: props.style?.strokeWidth }}
      />
    </SvgIcon>
  );
};

export const CableLowAwTop = (props: SvgIconProps) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 100 20">
      <line
        x1="0"
        y1="10"
        x2="40"
        y2="10"
        style={{ strokeWidth: props.style?.strokeWidth }}
      />
      <line
        x1="60"
        y1="10"
        x2="100"
        y2="10"
        style={{ strokeWidth: props.style?.strokeWidth }}
      />
    </SvgIcon>
  );
};

export const CableAerial = (props: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 300 300"
      // strokeWidth={props.style?.strokeWidth ? props.style?.strokeWidth : 1}
    >
      <path
        d="M0,150
             Q75,-120 150,150
             T300 150"
        fill="none"
        style={{ strokeWidth: props.style?.strokeWidth }}
      />
    </SvgIcon>
  );
};

export const RelayDefault = (props: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 100 100"
    >
      <rect x="15" y="20" width="75" height="75" style={{ strokeWidth: 2.5 }} />
      <polygon
        points="35,15 35,1 15,15"
        style={{
          strokeWidth: 2,
          stroke: props.style?.stroke,
          fill: props.style?.stroke,
        }}
      />
      <line x1="15" y1="15" x2="90" y2="15" style={{ strokeWidth: 2 }} />
      {props.children}
    </SvgIcon>
  );
};
export const RelayPh = (props: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 100 100"
    >
      <rect x="15" y="20" width="75" height="75" style={{ strokeWidth: 2.5 }} />
      <polygon
        points="70,15 70,1 90,15"
        style={{
          strokeWidth: 2,
          stroke: props.style?.stroke,
          fill: props.style?.stroke,
        }}
      />
      <line x1="15" y1="15" x2="90" y2="15" style={{ strokeWidth: 2 }} />
      {props.children}
    </SvgIcon>
  );
};

export const RelayLabel = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 100 100">
      <text x="50" y="70" fontSize={48} stroke="none" textAnchor="middle">
        {props.children}
      </text>
    </SvgIcon>
  );
};

export const TriangleDefault = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
    >
      <polygon points="20,80 50,20 80,80" />
    </SvgIcon>
  );
};

export const SwitchDefault = (props: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 100 100"
    >
      <line x1="1" y1="50" x2="40" y2="50" />
      <line x1="65" y1="50" x2="99" y2="50" />
      <line x1="60" y1="45" x2="85" y2="25" />
      <circle cx="50" cy="50" r="10" />
    </SvgIcon>
  );
};

export const SwitchDrop = (props: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 100 100"
    >
      <line x1="1" y1="50" x2="40" y2="50" />
      <line x1="65" y1="50" x2="99" y2="50" />
      <line x1="60" y1="45" x2="85" y2="25" />
      <circle cx="50" cy="50" r="10" />
      <text
        transform="matrix(0.64, 0.77, -0.77, 0.64, 60, 35)"
        strokeWidth={0}
        fill={props.style?.stroke}
        fillOpacity={props.style?.strokeOpacity}
      >
        S
      </text>
    </SvgIcon>
  );
};

export const SwitchDAS = (props: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 100 100"
    >
      <polygon points="1,20 99,20 99,80 1,80" />
      {props.children}
    </SvgIcon>
  );
};

export const SwitchDASLabel = (props: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 100 100"
    >
      <text x="50" y="65" stroke="none" textAnchor="middle" fontSize={40}>
        DAS
      </text>
    </SvgIcon>
  );
};

export const MeterDefault = (props: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 100 100"
    >
      <line x1="1" y1="50" x2="99" y2="50" />
      <line x1="75" y1="25" x2="99" y2="50" />
    </SvgIcon>
  );
};

export const Meter3Fase = (props: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 100 100"
    >
      <line x1="1" y1="50" x2="99" y2="50" />
      <line x1="75" y1="25" x2="99" y2="50" />
      <line x1="75" y1="75" x2="99" y2="50" />
    </SvgIcon>
  );
};

export const GroupMeter = (props: SvgIconProps) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 50 50">
      <line x1="0" y1="25" x2="50" y2="25" />
      <line x1="25" y1="0" x2="25" y2="50" />
    </SvgIcon>
  );
};

export const MeterHighTension = (props: SvgIconProps) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 50 50">
      {/* <polygon points="1,1 99,1 99,99 1,99" /> */}
      <rect x="10" y="10" width="30" height="30" />
      {props.children}
    </SvgIcon>
  );
};

export const MeterHighTensionLabel = (props: SvgIconProps) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 50 50">
      <text x="25" y="35" stroke="none" textAnchor="middle" fontSize={30}>
        H
      </text>
    </SvgIcon>
  );
};

export const RiserTransformerDefault = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="20 0 100 60"
    >
      <rect x="40" y="1" width="59" height="59" />
      <polygon points="45,50 70,5 94,50" />
      <polygon
        points="60,55 70,40 80,55"
        fill={props.style?.stroke}
        fillOpacity={props.style?.strokeOpacity}
        strokeOpacity={0}
      />
      <line x1="70" y1="55" x2="70" y2="60" />
    </SvgIcon>
  );
};

export const CircleDefault = (props: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 100 100"
    >
      <circle cx="50" cy="50" r="45" />
    </SvgIcon>
  );
};

export const RectangleDefault = (props: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 100 100"
    >
      <rect x="3" y="3" rx="3" ry="3" width="94" height="94" />
    </SvgIcon>
  );
};

export const LineDefault = (props: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 100 100"
    >
      <line x1="0" y1="100" x2="100" y2="0" />
    </SvgIcon>
  );
};
